/**
 * Caller form fields catalogue (qrUserDetails): the custom fields a QR
 * can ask the caller to fill before starting the call.
 */

import { useMemo, useState } from 'react';
import { List, TextField, FunctionField, useTranslate } from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

export const CallerFieldList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['field_name', 'type']} />}
        sort={{ field: 'qr_user_detail_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="field_name" secondarySource="type" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} />
          <TextField source="field_name" />
          <FunctionField
            source="type"
            render={(record: any) =>
              translate(`resources.qrUserDetails.types.${record?.type}`, { _: record?.type })
            }
          />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default CallerFieldList;
